<template>
	<BModal id="jobNotDoneModal" title="Job Not Done"
		ok-title="Submit" cancel-title="Cancel"
		@ok="submit">
		<h3>Why was this job not done?</h3>
		<p>We will contact the client to confirm that the job was not done and then clear the amount owing.</p>
		<BFormGroup label="Please select the reason that this job was not done.">
			<BFormSelect class="custom-select" :model-value="selectedReason"
				:options="reasonOptions"
				required @update:model-value="selectedReason = $event">
				<template #first>
					<BFormSelectOption value="">
						-- Select a reason --
					</BFormSelectOption>
				</template>
			</BFormSelect>
		</BFormGroup>
		<BFormGroup v-if="requiresConfirmation">
			<BFormCheckbox :model-value="confirmed" :value="true"
				:unchecked-value="false" @update:model-value="confirmed = $event">
				{{ confirmationMessage }}
			</BFormCheckbox>
		</BFormGroup>
	</BModal>
</template>

<script>
	import { useForgivenReasons } from '@js/composables/useForgivenReasons.js';

	export default {
		name: 'JobNotDoneModal',
		setup() {
			return {
				...useForgivenReasons(),
			};
		},
		data() {
			return {
				fee: null,
				selectedReason: '',
				confirmed: false,
			};
		},
		computed: {
			cleanerForgivenReasons() {
				return this.forgivenReasons.filter((reason) => reason.show_to_cleaner === true);
			},
			reasonOptions() {
				return this.cleanerForgivenReasons.map((reason) => ({
					value: reason.label,
					text: reason.label,
				}));
			},
			selectedReasonObject() {
				return this.cleanerForgivenReasons.find((reason) => reason.label === this.selectedReason);
			},
			requiresConfirmation() {
				return this.selectedReasonObject?.requires_confirmation || false;
			},
			confirmationMessage() {
				return this.selectedReasonObject?.confirmation_message || '';
			},
		},
		mounted() {
			this.$eventBus.$on('jobNotDoneModal.open', (fee) => {
				this.fee = fee;
				this.selectedReason = '';
				this.confirmed = false;
				this.$bvModal.show('jobNotDoneModal');
			});
		},
		beforeUnmount() {
			this.$eventBus.$off('jobNotDoneModal.open');
		},
		methods: {
			async submit(event) {
				event.preventDefault();

				if (!this.selectedReason) {
					toastr.error('Please select a reason.');
					return;
				}

				if (this.requiresConfirmation && !this.confirmed) {
					toastr.error('Please confirm the reason.');
					return;
				}

				try {
					await this.$axios.post('/api/cleaner/forgive-fees', {
						fees: [
							{
								id: this.fee.id,
								reason: this.selectedReason,
								service_date: this.fee.service?.date,
							},
						],
					});

					toastr.success('The fee has been forgiven and the client will be contacted to confirm.');
					this.$eventBus.$emit('fees.forgiven', [this.fee.id]);
					this.$bvModal.hide('jobNotDoneModal');
				} catch (error) {
					toastr.error(error.response?.data?.message || 'There was an error forgiving the fee.');
				}
			},
		},
	};
</script>

<style scoped></style>
